import { call, fork, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import UpdatesClient from 'rest/UpdatesClient';
import { errorAction } from 'components/utility/actions';
import * as restartActions from 'components/widgets/Restart/actions';
import * as actions from './actions';

export const updatesClient = new UpdatesClient();

export function *fetchUpdates(action) {
	try {
		const { data } = yield call([ updatesClient, updatesClient.get ]);
		yield put({ type: actions.FETCH_UPDATES_SUCCESS, payload: data });
	} catch (error) {
		yield put(errorAction(actions.FETCH_UPDATES_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeLatest, actions.FETCH_UPDATES, fetchUpdates);
	yield fork(takeLatest, restartActions.AWAIT_RESTART_SUCCESS, fetchUpdates);
}
